<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_black_label">登録スキルについて</h2>
      <p>予め登録頂けるスキルは下記になります。</p>
      <p>※マッチング検索は大項目のみで行っております。小項目はマッチング相手へ技量をアピールする目的で用意しております。</p>
      <p>項目追加のご要望は<a target="_blank" href="https://cadflew.com/contact/" class="link_label">こちら</a>からお願いいたします。</p>

      <div v-for="(skill, index) in SKILLS" :key="index">
        <p class="bold_label">□ {{skill.displayName}}</p>
        <div v-for="(child, childIndex) in skill.children" :key="childIndex">
          <p>□ {{child.displayName}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SKILLS from "@/assets/js/constants/skills";

  export default {
    name: "AboutSkills",

    components: {},

    beforeCreate() {
      Object.assign(this, {SKILLS});
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {

    > .contents {
      @include contents();

      > .large_black_label {
        margin: 2rem 0;
        width: 100%;
      }

      p {
        width: 100%;
      }

      > div {
        margin-top: 2rem;
        width: 100%;

        > div > p {
          margin-left: 1rem;
        }
      }
    }

    @media screen and (max-width: 767px) {
      > .contents {
        margin: 0 2.5%;
        width: 95%;
      }
    }
  }
</style>